// extracted by mini-css-extract-plugin
export default {"container":"lXjgWq","item":"TZ6_II","separator":"dczcyO","categoryPostLink":"zQxb_o"};